import type { AssetValidator, ValidationStage } from './types';

const registry = new Map<string, AssetValidator>();

export const registerValidator = (v: AssetValidator): void => {
  registry.set(v.key, v);
};

export const getValidators = (stage: ValidationStage): AssetValidator[] =>
  [...registry.values()].filter(v => v.runsOn.includes(stage));
